
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/company-details",
      function () {
        return require("private-next-pages/[lang]/company-details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/company-details"])
      });
    }
  